import { makeObservable } from 'mobx';
import {
    LoanApplicationDto,
    LoanApplicationDtoBrief,
} from 'src/generated-api-client';
import {
    agentLoanApplicationsApi,
    bpmsResourcesManagerApi,
} from 'src/services/apiServices';
import { InitialFilters } from 'src/stores/AgentLoanApplicationsStore/InitialFilters';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { RequestHelper } from 'src/utils/RequestHelper';

export type LoanApplicationsFilter = {
    search?: string;
    issueDateFrom?: moment.Moment;
    issueDateTo?: moment.Moment;
    status?: string[];
};

class AgentLoanApplicationsStoreClass extends BasicStore<
    LoanApplicationDtoBrief,
    LoanApplicationsFilter,
    unknown,
    unknown,
    LoanApplicationDto
> {
    constructor() {
        super();
        makeObservable(this);
    }

    itemPathKey = 'agentLoanApplicationId';
    itemDetailsFormKey =
        'embedded:deployment:forms/ap/ap-08-loan-application-info.json';

    api: BasicStoreApi<
        LoanApplicationDtoBrief,
        unknown,
        unknown,
        LoanApplicationDto
    > = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);
            const response = await RequestHelper.unwrapFromAxiosPromise(
                agentLoanApplicationsApi.findAllAgentApplications(
                    {
                        page: this.pager?.page,
                        size: this.pager?.size,
                        sort: InitialFilters.defaultSort,
                        filterStatuses: this.filterCriteria.filter.status,
                        filterRequestedAtFrom:
                            this.filterCriteria.filter.issueDateFrom?.toISOString(
                                true,
                            ),
                        filterRequestedAtTo:
                            this.filterCriteria.filter.issueDateTo?.toISOString(),
                        filterSearch: this.filterCriteria.filter.search,
                    },
                    options,
                ),
            );

            this.pager.setTotal(response.totalElements || 0);

            return response.content || [];
        },
        loadItem: (id, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                agentLoanApplicationsApi.getAgentApplication({ id }, options),
            );
        },
        loadItemForm: (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm(
                    { formKey: this.itemDetailsFormKey },
                    options,
                ),
            );
        },
    };

    filterCriteria = new FilterCriteria<LoanApplicationsFilter>();
    pager = new Pager();
}

export const AgentLoanApplicationsStore = new AgentLoanApplicationsStoreClass();
